import { render, staticRenderFns } from "./CourseForm.vue?vue&type=template&id=58deb42a&"
import script from "./CourseForm.vue?vue&type=script&lang=js&"
export * from "./CourseForm.vue?vue&type=script&lang=js&"
import style0 from "./CourseForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VBtn,VForm})
